export default __webpack_public_path__ + "static/media/hero-video.5b72dec4.mp4";